import { ForwardRefExoticComponent, forwardRef } from 'react'
import { TextFieldProps as MuiTextFieldProps } from '@mui/material/TextField'
import { TextField, TextFieldProps } from '../TextField/TextField'

export type TextAreaProps = TextFieldProps &
  Pick<MuiTextFieldProps, 'rows' | 'minRows' | 'maxRows'> & {
    size?: 'medium' | 'large'
  }

/**
 * TextArea is a styled variant of MUI's TextField.
 *
 * More info can be found at: https://mui.com/material-ui/react-text-field/
 */

export const TextArea: ForwardRefExoticComponent<TextAreaProps> = forwardRef(
  ({ rows = 3, ...rest }, ref) => {
    return <TextField ref={ref} rows={rows} multiline {...rest} />
  }
)
TextArea.displayName = 'TextArea'
